import { ArrowDown, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const GAP_CHAIN = [
  { name: "Agency need", desc: "What the mission actually requires" },
  { name: "Procurement requirements", desc: "What the solicitation asks for" },
  { name: "Vendor interpretation", desc: "What the bidder thinks you meant" },
  { name: "Implementation", desc: "What actually gets built" },
  { name: "User outcome", desc: "What people experience" },
];

export default function GapSection() {
  return (
    <section data-testid="gap-section" className="border-b border-line bg-white">
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-28">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="mb-6 flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-slate-500">
                <span className="h-px w-10 bg-slate-300" aria-hidden="true" />
                02 — WHERE WE SIT
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-serif text-3xl leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
                Between the business problem and the technology implementation.
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-8 max-w-md leading-relaxed text-slate-600">
                The organization understands its mission. The implementation vendor
                understands how to build and configure technology. Improve Systems makes
                sure those two sides stay connected.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="font-mono text-[10px] tracking-[0.3em] text-slate-400">
                [FIG.03] — WHERE MODERNIZATION FAILS
              </p>
              <div className="mt-6 flex flex-col md:flex-row md:items-stretch" role="group" aria-label="The gap between need and outcome">
                {GAP_CHAIN.map((node, i) => (
                  <div key={node.name} className="flex flex-col md:flex-1 md:flex-row md:items-stretch">
                    <div
                      data-testid={`gap-node-${i}`}
                      className="flex-1 border border-line bg-canvas p-4"
                    >
                      <span className="block font-mono text-[10px] text-slate-400">
                        0{i + 1}
                      </span>
                      <span className="mt-1 block text-sm font-medium leading-snug tracking-wide text-ink">
                        {node.name}
                      </span>
                      <span className="mt-1.5 block text-xs leading-snug text-slate-500">
                        {node.desc}
                      </span>
                    </div>
                    {i < GAP_CHAIN.length - 1 && (
                      <div className="flex items-center justify-center py-1 md:px-1 md:py-0" aria-hidden="true">
                        <ArrowRight className="hidden h-3.5 w-3.5 text-amber-600 md:block" />
                        <ArrowDown className="h-3.5 w-3.5 text-amber-600 md:hidden" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="mt-8 border-l-2 border-amber-600 bg-canvas p-6">
                <p className="font-serif text-xl italic leading-snug text-ink">
                  Modernization efforts rarely fail inside these steps. They fail between
                  them.
                </p>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-600">
                  We own that gap — and it is widest in government modernization, where the
                  distance between agency need and actual user outcome is longest.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
